import {
    Button,
    Flex,
    Heading,
    Slider,
    SliderFilledTrack,
    SliderTrack,
    Text,
    VStack,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { ActionContainer } from '../components/LandingPageComponents/styles/SplashStyles';
import { useScreenWidth } from 'hooks/useScreenWidth';

const Action = () => {
    const navigate = useNavigate();
    const screen = useScreenWidth();

    return (
        <ActionContainer>
            <Flex w="90%" mx="auto" h="full" justify="start" alignItems="start" flexDir="column">
                <Slider aria-label="slider-ex-4" defaultValue={10} mt="1rem">
                    <SliderTrack bg="#E8ECED" display={{ base: 'flex', lg: 'none' }}>
                        <SliderFilledTrack bg="#6B4EFF" />
                    </SliderTrack>
                </Slider>
                <Heading
                    as="h2"
                    w={{ base: '95%', lg: '30%' }}
                    mx="auto"
                    mt="25px"
                    mb="5px"
                    color="#090A0A"
                    fontSize="32px"
                    lineHeight="36px">
                    Here are Actions Steps to Get Started{' '}
                </Heading>

                <Text
                    w={{ base: '95%', lg: '30%' }}
                    mx="auto"
                    color="#090A0A"
                    fontSize="16px"
                    lineHeight="24px"
                    mt={{ base: '20%', lg: '60px' }}>
                    We will recommend you follow these process to get started
                </Text>

                <VStack
                    alignItems="start"
                    mt={{ base: '10%', lg: '30px' }}
                    gap=".5rem"
                    w={{ base: '95%', lg: '30%' }}
                    mx="auto">
                    <Button
                        colorScheme="none"
                        borderRadius="48px"
                        color="#090A0A"
                        bg="unset"
                        h="48px"
                        fontWeight="400"
                        border="1px solid #e2e2e2"
                        p="16px 24px"
                        _hover={{
                            bg: '#E7E7FF',
                            color: '#1b3b5f',
                            fontWeight: '700',
                        }}
                        onClick={() => navigate('/dashboard/profile/user', { replace: true })}>
                        1. Complete Profile
                    </Button>
                    <Button
                        colorScheme="none"
                        borderRadius="48px"
                        color="#090A0A"
                        bg="unset"
                        h="48px"
                        fontWeight="400"
                        border="1px solid #e2e2e2"
                        p="16px 24px"
                        _hover={{
                            bg: '#E7E7FF',
                            color: '#1b3b5f',
                            fontWeight: '700',
                        }}
                        onClick={() =>
                            navigate(screen > 500 ? '/dashboard/coming-soon' : '/coming-soon', {
                                replace: true,
                            })
                        }>
                        {/* // onClick={() => navigate('/training', { replace: true })}> */}
                        2. Get Certified (Get Trained)
                    </Button>

                    <Button
                        colorScheme="none"
                        h="48px"
                        borderRadius="48px"
                        color="#090A0A"
                        fontWeight="400"
                        cursor="not-allowed"
                        border="1px solid #e2e2e2"
                        p="16px 24px"
                        disabled={true}
                        onClick={() => {}}>
                        3. Start Selling
                    </Button>
                    <Button
                        colorScheme="none"
                        borderRadius="48px"
                        color="#090A0A"
                        bg="unset"
                        h="48px"
                        fontWeight="400"
                        border="1px solid #e2e2e2"
                        p="16px 24px"
                        _hover={{
                            bg: '#E7E7FF',
                            color: '#1b3b5f',
                            fontWeight: '700',
                        }}
                        onClick={() => navigate('/dashboard')}>
                        Skip for now
                    </Button>
                </VStack>
            </Flex>
        </ActionContainer>
    );
};

export default Action;
